'use strict';

var accounting = require('accounting'),
    stringUtils = require('../string');

module.exports = function (currencyOptions) {
  return {
    format: function format(value, currencyType) {
      if (isNaN(value) || parseInt(value, 10) !== value) {
        throw new Error('value must be an integer');
      } else if (typeof currencyType !== 'string') {
        throw new Error('currencyType must be a string');
      }

      var options = currencyOptions.tokens[currencyType];

      if (options === undefined) {
        throw new Error('specified currencyType is not supported');
      }

      value /= Math.pow(10, options.precision);

      if (currencyOptions.customFormatters[currencyType]) {
        return currencyOptions.customFormatters[currencyType].bind(options)(value);
      }

      return accounting.formatMoney(value, options);
    },

    formatForExport: function formatForExport(value, currencyType) {
      if (isNaN(value) || parseInt(value, 10) !== value) {
        throw new Error('value must be an integer');
      } else if (typeof currencyType !== 'string') {
        throw new Error('currencyType must be a string');
      }

      var options = currencyOptions.tokens[currencyType];

      if (options === undefined) {
        throw new Error('specified currencyType is not supported');
      }

      // Since JavaScript is terrible at numbers, instead of just dividing by a power
      // of 10 and returning the result, need to convert to a string to ensure correct
      // decimal precision.

      value = value + '';

      var length = value.length,
          precision = options.precision;

      if (precision === 0) {
        return value;
      } else if (length <= precision) {
        return '0.' + stringUtils.pad(value, precision);
      }

      return [value.substring(0, length - precision), value.substring(length - precision)].join('.');
    },

    parse: function parse(value, currencyType) {
      if (typeof value !== 'string') {
        throw new Error('value must be a string');
      } else if (typeof currencyType !== 'string') {
        throw new Error('currencyType must be a string');
      }

      var options = currencyOptions.tokens[currencyType];

      if (options === undefined) {
        throw new Error('specified currencyType is not supported');
      }

      // accounting.parse fails silently and returns 0 if value can't be parsed. Do a
      // quick pre-check and throw if value is obviously un-parse-able.

      // Strip all characters other than numerals and the specified decimal separator,
      // then replace the decimal separator with a period, then ensure the result can
      // be parsed as a float.
      var pattern = new RegExp('[^0-9-' + options.decimal + ']', ['g']),
          zeroFollowedByNonDecimal = new RegExp('[' + options.decimal + '](?!\\d)', ['g']);

      value = value.replace(zeroFollowedByNonDecimal, '');

      var parsed = parseFloat(value.replace(pattern, '').replace(options.decimal, '.'));

      if (isNaN(parsed)) {
        throw new Error('specified value could not be parsed');
      }

      return Math.round(accounting.parse(value, options.decimal) * Math.pow(10, options.precision));
    }
  };
};

module.exports.options = require('./options');